import React, { useEffect } from 'react';
import { Checkbox, Row, Col } from 'antd';
import { useFormContext, Controller } from 'react-hook-form';
import AddressBlock from '../../shared/AddressBlock';
import FormField from '../../shared/FormField';
import FileUploadField from '../../shared/FileUploadField';
import { CategoriaArquivo } from '@engenharia/shared';
import { useFormStore } from '../../../store/formStore';

interface Props {
  isVendaConcluida: boolean;
  onUpload: (categoria: any, file: File) => void;
  onDelete: (id: number) => void;
  uploadStates: Record<string, { uploading: boolean; progress: number }>;
}

export default function EnderecoInstalacaoSection({ isVendaConcluida, onUpload, onDelete, uploadStates }: Props) {
  const { watch, control, setValue, getValues } = useFormContext();
  const arquivos = useFormStore((s) => s.arquivos);
  const mesmoEndereco = watch('mesmo_endereco');
  const localizacao = watch('tipo_localizacao');

  useEffect(() => {
    if (mesmoEndereco && isVendaConcluida) {
      const fat = getValues('endereco_faturamento');
      if (fat) {
        setValue('endereco_instalacao', { ...fat }, { shouldValidate: true });
      }
    }
  }, [mesmoEndereco]);

  return (
    <div className="border rounded-lg p-4 mb-4">
      <h3 className="text-lg font-semibold mb-4">Endereço de Instalação</h3>

      {isVendaConcluida && (
        <div className="mb-4">
          <Controller
            name="mesmo_endereco"
            control={control}
            render={({ field }) => (
              <Checkbox checked={field.value} onChange={(e) => field.onChange(e.target.checked)}>
                Mesmo endereço de faturamento
              </Checkbox>
            )}
          />
        </div>
      )}

      {!mesmoEndereco && <AddressBlock prefix="endereco_instalacao" />}

      <Row gutter={16}>
        <Col xs={24} sm={12}>
          <FormField name="url_local_instalacao" label="URL do Local de Instalação" placeholder="https://..." />
        </Col>
        <Col xs={24} sm={12}>
          <FormField name="coordenada_geografica" label="Coordenada Geográfica" />
        </Col>
      </Row>

      <FileUploadField
        label="Print Localização"
        categoria={CategoriaArquivo.PrintLocalizacao}
        arquivos={arquivos}
        uploading={uploadStates[CategoriaArquivo.PrintLocalizacao]?.uploading || false}
        progress={uploadStates[CategoriaArquivo.PrintLocalizacao]?.progress || 0}
        onUpload={onUpload}
        onDelete={onDelete}
      />

      <FileUploadField
        label="Comprovante de Endereço (Instalação)"
        categoria={CategoriaArquivo.ComprovanteEnderecoInstalacao}
        arquivos={arquivos}
        uploading={uploadStates[CategoriaArquivo.ComprovanteEnderecoInstalacao]?.uploading || false}
        progress={uploadStates[CategoriaArquivo.ComprovanteEnderecoInstalacao]?.progress || 0}
        required
        onUpload={onUpload}
        onDelete={onDelete}
      />

      {localizacao === 'rural' && (
        <FileUploadField
          label="Print Transformador"
          categoria={CategoriaArquivo.PrintTransformador}
          arquivos={arquivos}
          uploading={uploadStates[CategoriaArquivo.PrintTransformador]?.uploading || false}
          progress={uploadStates[CategoriaArquivo.PrintTransformador]?.progress || 0}
          onUpload={onUpload}
          onDelete={onDelete}
        />
      )}
    </div>
  );
}
